import { render, staticRenderFns } from "./AddUpdateTechTime.vue?vue&type=template&id=8984fb4a&scoped=true"
import script from "./AddUpdateTechTime.vue?vue&type=script&lang=js"
export * from "./AddUpdateTechTime.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateTechTime.vue?vue&type=style&index=0&id=8984fb4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8984fb4a",
  null
  
)

export default component.exports